export const GA_TRACKING_ID = 'G-57ZFJMENEH'

declare global {
    interface Window { gtag: (action: string, param: string, data: any) => void; }
}

// https://developers.google.com/analytics/devguides/collection/gtagjs/pages
export const logPageView = (url: string) => {
  window.gtag('config', GA_TRACKING_ID, {
    page_location: url
  })
};

// https://developers.google.com/analytics/devguides/collection/gtagjs/events
export const customEvent = (action: string, data: any) => {
  window.gtag('event', action, data)
};
